
    import './styles.scoped.css';
    export default {
  "box": "awsui_box_18wu0_12hp5_168",
  "p-variant": "awsui_p-variant_18wu0_12hp5_168",
  "color-default": "awsui_color-default_18wu0_12hp5_168",
  "b-variant": "awsui_b-variant_18wu0_12hp5_168",
  "strong-variant": "awsui_strong-variant_18wu0_12hp5_168",
  "code-variant": "awsui_code-variant_18wu0_12hp5_168",
  "pre-variant": "awsui_pre-variant_18wu0_12hp5_168",
  "samp-variant": "awsui_samp-variant_18wu0_12hp5_168",
  "h1-variant": "awsui_h1-variant_18wu0_12hp5_172",
  "h2-variant": "awsui_h2-variant_18wu0_12hp5_172",
  "h3-variant": "awsui_h3-variant_18wu0_12hp5_172",
  "h4-variant": "awsui_h4-variant_18wu0_12hp5_172",
  "h5-variant": "awsui_h5-variant_18wu0_12hp5_172",
  "small-variant": "awsui_small-variant_18wu0_12hp5_176",
  "a-variant": "awsui_a-variant_18wu0_12hp5_180",
  "font-size-default": "awsui_font-size-default_18wu0_12hp5_184",
  "font-weight-default": "awsui_font-weight-default_18wu0_12hp5_225",
  "key-label-variant": "awsui_key-label-variant_18wu0_12hp5_267",
  "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_12hp5_274",
  "value-large-variant": "awsui_value-large-variant_18wu0_12hp5_281",
  "inline-code-variant": "awsui_inline-code-variant_18wu0_12hp5_291",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_12hp5_305",
  "color-inverted": "awsui_color-inverted_18wu0_12hp5_310",
  "color-text-label": "awsui_color-text-label_18wu0_12hp5_313",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_12hp5_316",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_12hp5_319",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_12hp5_322",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_12hp5_325",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_12hp5_328",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_12hp5_331",
  "color-inherit": "awsui_color-inherit_18wu0_12hp5_334",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_12hp5_337",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_12hp5_342",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_12hp5_346",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_12hp5_351",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_12hp5_356",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_12hp5_361",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_12hp5_366",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_12hp5_371",
  "font-size-display-xl": "awsui_font-size-display-xl_18wu0_12hp5_376",
  "font-weight-light": "awsui_font-weight-light_18wu0_12hp5_381",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_12hp5_384",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_12hp5_387",
  "t-left": "awsui_t-left_18wu0_12hp5_394",
  "t-right": "awsui_t-right_18wu0_12hp5_398",
  "t-center": "awsui_t-center_18wu0_12hp5_402",
  "p-n": "awsui_p-n_18wu0_12hp5_419",
  "p-top-n": "awsui_p-top-n_18wu0_12hp5_424",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_12hp5_425",
  "p-right-n": "awsui_p-right-n_18wu0_12hp5_429",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_12hp5_430",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_12hp5_434",
  "p-left-n": "awsui_p-left-n_18wu0_12hp5_439",
  "p-xxxs": "awsui_p-xxxs_18wu0_12hp5_444",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_12hp5_449",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_12hp5_450",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_12hp5_454",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_12hp5_455",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_12hp5_459",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_12hp5_464",
  "p-xxs": "awsui_p-xxs_18wu0_12hp5_469",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_12hp5_474",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_12hp5_475",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_12hp5_479",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_12hp5_480",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_12hp5_484",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_12hp5_489",
  "p-xs": "awsui_p-xs_18wu0_12hp5_494",
  "p-top-xs": "awsui_p-top-xs_18wu0_12hp5_499",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_12hp5_500",
  "p-right-xs": "awsui_p-right-xs_18wu0_12hp5_504",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_12hp5_505",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_12hp5_509",
  "p-left-xs": "awsui_p-left-xs_18wu0_12hp5_514",
  "p-s": "awsui_p-s_18wu0_12hp5_519",
  "p-top-s": "awsui_p-top-s_18wu0_12hp5_524",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_12hp5_525",
  "p-right-s": "awsui_p-right-s_18wu0_12hp5_529",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_12hp5_530",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_12hp5_534",
  "p-left-s": "awsui_p-left-s_18wu0_12hp5_539",
  "p-m": "awsui_p-m_18wu0_12hp5_544",
  "p-top-m": "awsui_p-top-m_18wu0_12hp5_549",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_12hp5_550",
  "p-right-m": "awsui_p-right-m_18wu0_12hp5_554",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_12hp5_555",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_12hp5_559",
  "p-left-m": "awsui_p-left-m_18wu0_12hp5_564",
  "p-l": "awsui_p-l_18wu0_12hp5_439",
  "p-top-l": "awsui_p-top-l_18wu0_12hp5_574",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_12hp5_575",
  "p-right-l": "awsui_p-right-l_18wu0_12hp5_579",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_12hp5_580",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_12hp5_584",
  "p-left-l": "awsui_p-left-l_18wu0_12hp5_589",
  "p-xl": "awsui_p-xl_18wu0_12hp5_594",
  "p-top-xl": "awsui_p-top-xl_18wu0_12hp5_599",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_12hp5_600",
  "p-right-xl": "awsui_p-right-xl_18wu0_12hp5_604",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_12hp5_605",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_12hp5_609",
  "p-left-xl": "awsui_p-left-xl_18wu0_12hp5_614",
  "p-xxl": "awsui_p-xxl_18wu0_12hp5_619",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_12hp5_624",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_12hp5_625",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_12hp5_629",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_12hp5_630",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_12hp5_634",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_12hp5_639",
  "p-xxxl": "awsui_p-xxxl_18wu0_12hp5_644",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_12hp5_649",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_12hp5_650",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_12hp5_654",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_12hp5_655",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_12hp5_659",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_12hp5_664",
  "m-n": "awsui_m-n_18wu0_12hp5_669",
  "m-top-n": "awsui_m-top-n_18wu0_12hp5_674",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_12hp5_675",
  "m-right-n": "awsui_m-right-n_18wu0_12hp5_679",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_12hp5_680",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_12hp5_684",
  "m-left-n": "awsui_m-left-n_18wu0_12hp5_689",
  "m-xxxs": "awsui_m-xxxs_18wu0_12hp5_694",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_12hp5_699",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_12hp5_700",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_12hp5_704",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_12hp5_705",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_12hp5_709",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_12hp5_714",
  "m-xxs": "awsui_m-xxs_18wu0_12hp5_719",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_12hp5_724",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_12hp5_725",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_12hp5_729",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_12hp5_730",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_12hp5_734",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_12hp5_739",
  "m-xs": "awsui_m-xs_18wu0_12hp5_744",
  "m-top-xs": "awsui_m-top-xs_18wu0_12hp5_749",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_12hp5_750",
  "m-right-xs": "awsui_m-right-xs_18wu0_12hp5_754",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_12hp5_755",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_12hp5_759",
  "m-left-xs": "awsui_m-left-xs_18wu0_12hp5_764",
  "m-s": "awsui_m-s_18wu0_12hp5_769",
  "m-top-s": "awsui_m-top-s_18wu0_12hp5_774",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_12hp5_775",
  "m-right-s": "awsui_m-right-s_18wu0_12hp5_779",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_12hp5_780",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_12hp5_784",
  "m-left-s": "awsui_m-left-s_18wu0_12hp5_789",
  "m-m": "awsui_m-m_18wu0_12hp5_794",
  "m-top-m": "awsui_m-top-m_18wu0_12hp5_799",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_12hp5_800",
  "m-right-m": "awsui_m-right-m_18wu0_12hp5_804",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_12hp5_805",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_12hp5_809",
  "m-left-m": "awsui_m-left-m_18wu0_12hp5_814",
  "m-l": "awsui_m-l_18wu0_12hp5_689",
  "m-top-l": "awsui_m-top-l_18wu0_12hp5_824",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_12hp5_825",
  "m-right-l": "awsui_m-right-l_18wu0_12hp5_829",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_12hp5_830",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_12hp5_834",
  "m-left-l": "awsui_m-left-l_18wu0_12hp5_839",
  "m-xl": "awsui_m-xl_18wu0_12hp5_844",
  "m-top-xl": "awsui_m-top-xl_18wu0_12hp5_849",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_12hp5_850",
  "m-right-xl": "awsui_m-right-xl_18wu0_12hp5_854",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_12hp5_855",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_12hp5_859",
  "m-left-xl": "awsui_m-left-xl_18wu0_12hp5_864",
  "m-xxl": "awsui_m-xxl_18wu0_12hp5_869",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_12hp5_874",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_12hp5_875",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_12hp5_879",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_12hp5_880",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_12hp5_884",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_12hp5_889",
  "m-xxxl": "awsui_m-xxxl_18wu0_12hp5_894",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_12hp5_899",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_12hp5_900",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_12hp5_904",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_12hp5_905",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_12hp5_909",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_12hp5_914",
  "d-block": "awsui_d-block_18wu0_12hp5_919",
  "d-inline": "awsui_d-inline_18wu0_12hp5_922",
  "d-inline-block": "awsui_d-inline-block_18wu0_12hp5_925",
  "d-none": "awsui_d-none_18wu0_12hp5_928",
  "f-left": "awsui_f-left_18wu0_12hp5_932",
  "f-right": "awsui_f-right_18wu0_12hp5_936",
  "visual-accent": "awsui_visual-accent_18wu0_12hp5_944",
  "visual-accent-radius-xxxs": "awsui_visual-accent-radius-xxxs_18wu0_12hp5_953",
  "visual-accent-radius-xxs": "awsui_visual-accent-radius-xxs_18wu0_12hp5_960",
  "visual-accent-radius-xs": "awsui_visual-accent-radius-xs_18wu0_12hp5_967",
  "visual-accent-radius-s": "awsui_visual-accent-radius-s_18wu0_12hp5_974",
  "visual-accent-radius-m": "awsui_visual-accent-radius-m_18wu0_12hp5_981",
  "visual-accent-radius-l": "awsui_visual-accent-radius-l_18wu0_12hp5_988",
  "visual-accent-radius-xl": "awsui_visual-accent-radius-xl_18wu0_12hp5_995",
  "visual-accent-radius-xxl": "awsui_visual-accent-radius-xxl_18wu0_12hp5_1002",
  "visual-accent-radius-xxxl": "awsui_visual-accent-radius-xxxl_18wu0_12hp5_1009",
  "visual-accent-radius-full": "awsui_visual-accent-radius-full_18wu0_12hp5_1016",
  "visual-accent-aspect-auto": "awsui_visual-accent-aspect-auto_18wu0_12hp5_1023",
  "visual-accent-aspect-equal": "awsui_visual-accent-aspect-equal_18wu0_12hp5_1028",
  "visual-accent-red": "awsui_visual-accent-red_18wu0_12hp5_1036",
  "visual-accent-yellow": "awsui_visual-accent-yellow_18wu0_12hp5_1041",
  "visual-accent-indigo": "awsui_visual-accent-indigo_18wu0_12hp5_1046",
  "visual-accent-green": "awsui_visual-accent-green_18wu0_12hp5_1051",
  "visual-accent-orange": "awsui_visual-accent-orange_18wu0_12hp5_1056",
  "visual-accent-purple": "awsui_visual-accent-purple_18wu0_12hp5_1061",
  "visual-accent-lime": "awsui_visual-accent-lime_18wu0_12hp5_1066",
  "visual-accent-grey": "awsui_visual-accent-grey_18wu0_12hp5_1071",
  "visual-accent-teal": "awsui_visual-accent-teal_18wu0_12hp5_1076",
  "visual-accent-blue": "awsui_visual-accent-blue_18wu0_12hp5_1081",
  "visual-accent-violet": "awsui_visual-accent-violet_18wu0_12hp5_1086",
  "visual-accent-magenta": "awsui_visual-accent-magenta_18wu0_12hp5_1091",
  "visual-accent-pink": "awsui_visual-accent-pink_18wu0_12hp5_1096",
  "visual-accent-amber": "awsui_visual-accent-amber_18wu0_12hp5_1101",
  "root": "awsui_root_18wu0_12hp5_1106"
};
  